var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingStep04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.76 57.6279C16.48 53.7279 15.99 47.2879 15.99 47.0279V46.2579C14.89 47.1379 11.4 47.8479 8.67001 47.9779C8.10001 47.9979 7.92001 48.4579 7.92001 49.0279C7.73001 62.9479 17.17 71.4379 17.57 71.7979C17.76 71.9679 18.02 72.0679 18.28 72.0679C18.41 72.0679 18.55 72.0379 18.68 71.9879C20.99 71.0579 25.53 68.2379 29.42 65.0679L28.8 64.7479C28.52 64.5879 22.91 61.3779 19.76 57.6279Z",
    fill: "url(#paint0_linear_801_3431)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 43.9079L22.55 43.1879C22.39 43.2979 22.19 43.4079 21.98 43.5379C21.97 43.5379 21.94 43.5379 21.93 43.5379C21.19 43.9979 20.09 44.5879 18.83 45.1979C18.79 45.2179 18.63 45.2379 18.59 45.2579C18.54 45.2779 18.2 45.3079 18.2 45.3379V46.9879C18.2 46.9879 18.65 52.9279 21.44 56.2479C24.36 59.7179 29.81 62.8479 29.86 62.8879L31.19 63.5879C31.76 63.0879 32.29 62.5879 32.77 62.0979C32.79 62.0779 32.8 62.0679 32.82 62.0479C33.44 61.4279 33.97 60.8179 34.43 60.2479C34.49 60.1679 34.55 60.1079 34.6 60.0379C34.63 60.0079 34.65 59.9579 34.69 59.9279L33.97 59.6379C29.12 58.3579 23.89 47.9279 22.82 43.9079H22.8Z",
    fill: "url(#paint1_linear_801_3431)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.95 47.9779C68.22 47.8479 65.46 47.1379 63.27 46.2579V47.0279C63.27 47.2979 63.15 53.7279 59.87 57.6279C56.72 61.3779 51.48 64.5879 51.2 64.7479L50.58 65.0679C54.47 68.2279 59.01 71.0579 61.32 71.9879C61.45 72.0279 61.59 72.0679 61.72 72.0679C61.98 72.0679 62.23 71.9679 62.43 71.7979C62.84 71.4479 72.27 62.9479 72.08 49.0279C72.08 48.4579 71.52 47.9979 70.96 47.9779H70.95Z",
    fill: "url(#paint2_linear_801_3431)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2 56.2479C60.99 52.9379 61.07 47.0279 61.07 46.9879V45.3379C61.07 45.3379 61.1 45.2879 61.05 45.2579C61.01 45.2379 61.03 45.2179 60.99 45.1979C59.73 44.5879 58.72 43.9979 57.98 43.5379C57.77 43.4079 57.59 43.2879 57.43 43.1879L57.19 43.9079C56.12 47.9279 50.9 58.3579 46.04 59.6379L45.33 59.9279C45.33 59.9279 45.38 59.9979 45.42 60.0379C45.47 60.1179 45.53 60.1779 45.59 60.2479C46.05 60.8179 46.58 61.4279 47.2 62.0479C47.22 62.0679 47.23 62.0779 47.25 62.0979C47.73 62.5779 48.27 63.0779 48.83 63.5879L50.16 62.8879C50.21 62.8579 55.29 59.7279 58.21 56.2479H58.2Z",
    fill: "url(#paint3_linear_801_3431)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.19 43.2879L55.41 42.5679C52.83 39.3179 52.04 34.6079 51.52 31.3679C51.19 29.3879 50.98 28.0879 50.47 27.3479C49.53 25.9779 48.4 23.6179 47.85 21.8579C47.57 20.9879 47.19 18.5479 46.84 16.3879C46.47 14.0179 46.11 11.7779 45.8 10.7579C45.29 9.0679 43.53 7.7279 42 7.9579C41.88 7.9779 41.5 8.0379 41.13 8.3079C39.19 9.6979 40.06 14.7079 40.31 14.7079C40.55 14.7079 41.36 10.3079 39.43 8.5779C39.29 8.4479 38.84 8.0579 38.18 7.9579C36.65 7.7379 34.71 9.0679 34.2 10.7579C33.89 11.7879 33.54 14.0179 33.16 16.3879C32.82 18.5479 32.43 20.9979 32.16 21.8579C31.6 23.6179 30.48 25.9879 29.54 27.3479C29.03 28.0879 28.83 29.3879 28.5 31.3679C27.98 34.6079 27.21 39.3179 24.63 42.5679L24.9 43.2879C25.92 47.0679 29.93 54.4379 33.21 56.8479C39.56 54.0579 40.18 42.5479 40.18 38.8479C40.18 42.5479 40.62 54.0579 46.97 56.8479C50.25 54.4279 54.17 47.0679 55.19 43.2879Z",
    fill: "url(#paint4_linear_801_3431)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_801_3431",
    x1: 7.92001,
    y1: 59.1579,
    x2: 29.42,
    y2: 59.1579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_801_3431",
    x1: 18.19,
    y1: 53.3879,
    x2: 34.68,
    y2: 53.3879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_801_3431",
    x1: 50.58,
    y1: -26.8821,
    x2: 72.08,
    y2: -26.8821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_801_3431",
    x1: 45.32,
    y1: 53.3879,
    x2: 61.08,
    y2: 53.3879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_801_3431",
    x1: 24.63,
    y1: 32.3879,
    x2: 55.41,
    y2: 32.3879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingStep04);
export default __webpack_public_path__ + "static/media/booking-step-04.94e09205101c899471745ae8ebe00d07.svg";
export { ForwardRef as ReactComponent };